import { Divider, Stack } from '@mui/material';

export const ShortDivider = () => {
  return (
    <Stack alignItems="center">
      <Divider sx={{ width: '72px' }} variant="middle"/>
    </Stack>
  );
};
